// Fonction globale pour appliquer un code promo
window.applyDiscountCode = async function(blockId) {
  const input = document.getElementById('discount-input-' + blockId);
  const btn = document.getElementById('discount-btn-' + blockId);
  const msg = document.getElementById('discount-msg-' + blockId);
  const wrapper = btn?.closest('.cart-discount-code-wrapper');

  if (!input || !btn) return;

  // Récupérer les traductions depuis les data attributes
  const messages = {
    success: wrapper?.dataset.msgSuccess || 'Code promo appliqué !',
    error: wrapper?.dataset.msgError || 'Code promo invalide',
    empty: wrapper?.dataset.msgEmpty || 'Veuillez entrer un code'
  };

  const code = input.value.trim();
  if (!code) {
    if (msg) {
      msg.textContent = messages.empty;
      msg.className = 'cart-discount-code-message error';
    }
    return;
  }

  // Activer le loading
  btn.disabled = true;
  btn.classList.add('loading');
  if (msg) msg.textContent = '';

  // Appliquer le code via iframe
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
  iframe.src = '/discount/' + encodeURIComponent(code);

  iframe.onload = async () => {
    await new Promise(r => setTimeout(r, 500));

    const cart = await fetch('/cart.js').then(r => r.json());
    const applied = cart.discount_codes?.find(d => d.code.toUpperCase() === code.toUpperCase() && d.applicable);

    iframe.remove();

    if (applied) {
      if (msg) {
        msg.textContent = messages.success;
        msg.className = 'cart-discount-code-message success';
      }
      input.value = '';

      // Refresh cart drawer
      const res = await fetch(window.location.pathname + '?section_id=cart-drawer');
      const html = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }
    } else {
      if (msg) {
        msg.textContent = messages.error;
        msg.className = 'cart-discount-code-message error';
      }
    }

    // Désactiver le loading
    btn.disabled = false;
    btn.classList.remove('loading');
  };

  iframe.onerror = () => {
    btn.disabled = false;
    btn.classList.remove('loading');
    if (msg) {
      msg.textContent = messages.error;
      msg.className = 'cart-discount-code-message error';
    }
  };
};
